/**
 * Dashboard filter controls can be collapsed in the interactive view. Expand
 * only the cloned export node so PDF output continues to include current
 * filters without changing the visible dashboard state.
 */
export function expandCollapsedDashboardFiltersForExport(
  parametersNode: ParentNode,
) {
  const collapse = parametersNode.querySelector<HTMLElement>(
    '[data-dashboard-filter-collapsible="true"]',
  );

  if (!collapse) {
    return;
  }

  const elements = [collapse, ...collapse.querySelectorAll<HTMLElement>("*")];
  for (const element of elements) {
    if (element.style.height === "0px" || element.style.height === "0") {
      element.style.height = "auto";
    }
    if (element.style.opacity === "0") {
      element.style.opacity = "1";
    }
    if (element.style.visibility === "hidden") {
      element.style.visibility = "visible";
    }
    element.style.overflow = "visible";
    element.style.transition = "none";
    element.removeAttribute("aria-hidden");
  }
}
